import { $themeBreakpoints } from '@themeConfig'
import axios from '@/libs/axios'
import handleError from '@/views/components/errorHandler'

// Customs code lists are not cached here: they are served by the shared
// classifier client (@/libs/customsClassifiers), which owns one expiry policy
// for all of them. Invalidation codes are fixed per customs component rather
// than synced, so they keep their own endpoint and cache.
export default {
  namespaced: true,
  state: {
    windowWidth: 0,
    shallShowOverlay: false,
    shipmentCache: {},
    invalidationCodes: {},
  },
  getters: {
    currentBreakPoint: state => {
      const { windowWidth } = state
      if (windowWidth >= $themeBreakpoints.xl) return 'xl'
      if (windowWidth >= $themeBreakpoints.lg) return 'lg'
      if (windowWidth >= $themeBreakpoints.md) return 'md'
      if (windowWidth >= $themeBreakpoints.sm) return 'sm'
      return 'xs'
    },
    invalidationCodes: state => customsCountry => state.invalidationCodes[customsCountry] || [],
  },
  mutations: {
    UPDATE_WINDOW_WIDTH(state, val) {
      state.windowWidth = val
    },
    TOGGLE_OVERLAY(state, val) {
      state.shallShowOverlay = val !== undefined ? val : !state.shallShowOverlay
    },
    SET_INVALIDATION_CODES(state, { customsCountry, data }) {
      state.invalidationCodes = { ...state.invalidationCodes, [customsCountry]: data }
    },
  },
  actions: {
    async getInvalidationCodes({ commit, getters }, { customsCountry, toast }) {
      const cached = getters.invalidationCodes(customsCountry)
      if (cached.length !== 0) {
        return cached
      }

      try {
        const { data } = await axios.get(`/v1/customs/invalidation-codes/${customsCountry}`)
        commit('SET_INVALIDATION_CODES', { customsCountry, data })
        return data
      } catch (err) {
        handleError(err, toast, 'Failed to get invalidation codes')
        throw err
      }
    },
  },
}
